/* eslint-disable react/prefer-stateless-function */
/* eslint-disable import/prefer-default-export */
import React, { Component } from 'react';
import '../scss/custom.scss';
import '../scss/theme.scss';
import { Route, Link, Switch } from 'react-router-dom';
import ReactNotification from 'react-notifications-component';
import { Container } from 'reactstrap';
import { Home } from './Home';
import CalendarTasks from './dailytasks/MyCalendar';
import AllTheTasks from './dailytasks/AllTheTasks';
import BackOffice from './backoffice';
import LandingGlobal from './incident/LandingGlobal';
import NewIncidentReport from './incident/NewIncidentReport';
import CARList from './incident/CARList';
import CARDetail from './incident/CARDetail';
import CADetail from './incident/CADetail';
import AuditList from './audit/AuditList';
import AuditCARList from './audit/AuditCARList';
import AuditCARDetail from './audit/AuditCARDetail';
import AuditCADetail from './audit/AuditCADetail';
import { Profile } from './common/Profile';
import Functions from './functions/Functions';
import InspectionCARDetail from './inspection/inspectionReport/InspectionCARDetail';
import { Head } from './common/Header';
import { Authorization } from '../helpers/authorization/Authorization';
import ReportSummaryList from './report/ReportSummaryList';
import ReportSummaryDetail from './report/ReportSummaryDetail';
import Safety from './report/Safety';
import Enviroment from './report/Enviroment';
import AssetIntegrity from './report/AssetIntegrity';
import { HocCard } from './functions/HocCard';
import TrainingList from './training/TrainingList';
import { Inspection } from './inspection/Inspection';
import { InspectionReport } from './inspection/inspectionReport/InspectionReport';
import { InspectionCarList } from './inspection/inspectionReport/InspectionCarList';
import { Support } from './utilities/Support';
import { AppContext } from '../helpers/context/AppContext';
import AuditReport from './audit/AuditReport';
import HocCardDetail from './functions/HocCardDetail';
import EmergencyDrillList from './emergencydrill/EmergencyDrillList';
import DrillReportList from './emergencydrill/report/DrillReportList';
import { DrillReport } from './emergencydrill/report/DrillReport';
import DrillCARDetail from './emergencydrill/report/reportDetails/DrillCARDetail';
import { DrillCarList } from './emergencydrill/report/reportDetails/DrillCarList';
import AnnualDrillPlanDownload from './emergencydrill/AnnualDrillPlanDownload';

import { NewTraining } from './training/NewTraining';
import AuditProgram from './audit/AuditProgram';

export class Layout extends Component {
  displayName = Layout.name;

  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <div className="layout">
            <ReactNotification />
            <Head />

            <Container>
              <Switch>
                <Route exact path="/" component={Authorization(user, Home, 'Global', null, true)} />
              </Switch>

              <Route
                path="/backoffice"
                component={Authorization(user, BackOffice, 'Role', 'Administrator', true)}
              />

              <Switch>
                <Route
                  exact
                  path="/incident"
                  component={Authorization(user, LandingGlobal, 'Module', 'Incident', true)}
                />
                <Route
                  path="/incident/new"
                  component={Authorization(user, NewIncidentReport, 'Module', 'Incident', true)}
                />
                <Route
                  exact
                  path="/incident/:id"
                  component={Authorization(user, NewIncidentReport, 'Module', 'Incident', true)}
                />
                <Route exact path="/incident/:id/car" component={CARList} />
                <Route exact path="/incident/:id/car/:idCar" component={CARDetail} />

                <Route exact path="/incident/:id/car/:idCar/ca/:idCa" component={CADetail} />
              </Switch>

              <Route
                path="/modules"
                component={Authorization(user, Functions, 'Global', null, true)}
              />

              <Route
                path="/alltasks"
                component={Authorization(user, AllTheTasks, 'Global', null, true)}
              />
              <Route
                path="/dailytasks"
                component={Authorization(user, CalendarTasks, 'Global', null, true)}
              />

              <Switch>
                <Route
                  exact
                  path="/audit/program/:id?"
                  component={Authorization(user, AuditProgram, 'Module', 'Audit', true)}
                />
                <Route
                  exact
                  path="/audit/:id"
                  component={Authorization(user, AuditReport, 'Module', 'Audit', true)}
                />

                {/* <Route
                  exact
                  path="/audit/program"
                  component={Authorization(user, AuditProgram, 'Module', 'Audit', true)}
                /> */}
                <Route exact path="/audit/:id/:newMng/car" component={AuditCARList} />
                <Route exact path="/audit/:id/:newMng/answer/:idAnswer/car" component={AuditCARList} />
                <Route
                  exact
                  path="/audit/:id/:newMng/answer/:idAnswer/car/:idCar"
                  component={AuditCARDetail}
                />
                <Route
                  exact
                  path="/audit/:id/:newMng/answer/:idAnswer/car/:idCar/ca/:idCa"
                  component={AuditCADetail}
                />
              </Switch>

              <Switch>
                <Route
                  exact
                  path="/drill"
                  component={Authorization(
                    user,
                    EmergencyDrillList,
                    'Module',
                    'Emergency Drill',
                    true
                  )}
                />
                <Route
                  exact
                  path="/drill/:id/reports"
                  component={Authorization(
                    user,
                    DrillReportList,
                    'Module',
                    'Emergency Drill',
                    true
                  )}
                />
                <Route
                  exact
                  path="/drill/report/:id"
                  component={Authorization(user, DrillReport, 'Module', 'Emergency Drill', true)}
                />
                <Route exact path="/drill/report/:id/car" component={DrillCarList} />
                <Route exact path="/drill/report/answer/car/:idCar" component={DrillCARDetail} />
                <Route exact path="/drill/exportannualdrillplanbylink/ws/:year/:id/:hver/:hash" component={AnnualDrillPlanDownload} /> {/*RITM0860478*/ }
                
              </Switch>

              <Route
                path="/listofaudit"
                component={Authorization(user, AuditList, 'Module', 'Audit', true)}
              />

              <Route
                path="/profile"
                component={Authorization(user, Profile, 'Global', null, true)}
              />

              <Route
                exact
                path="/reportSummaries"
                component={Authorization(user, ReportSummaryList, 'Module', 'Report', true)}
              />
              <Route
                exact
                path="/reportSummaries/:idReportSummary"
                component={Authorization(user, ReportSummaryDetail, 'Module', 'Report', true)}
              />
              <Route
                exact
                path="/reportSummaries/:idReportSummary/safety/:idReport"
                component={Authorization(user, Safety, 'Module', 'Report', true)}
              />
              <Route
                exact
                path="/reportSummaries/:idReportSummary/environment/:idReport"
                component={Authorization(user, Enviroment, 'Module', 'Report', true)}
              />
              <Route
                exact
                path="/reportSummaries/:idReportSummary/asset Integrity/:idReport"
                component={Authorization(user, AssetIntegrity, 'Module', 'Report', true)}
              />

              <Switch>
                <Route
                  exact
                  path="/hoccard"
                  component={Authorization(user, HocCard, 'Module', 'Hoc Card', true)}
                />
                <Route
                  exact
                  path="/hoccard/new"
                  component={Authorization(user, HocCardDetail, 'Module', 'Hoc Card', true)}
                />
                <Route
                  exact
                  path="/hoccard/:id"
                  component={HocCardDetail}
                />
              </Switch>

              <Switch>
                <Route
                  exact
                  path="/inspection"
                  component={Authorization(user, Inspection, 'Module', 'Inspection', true)}
                />
                <Route exact path="/inspection/:id" component={InspectionReport} />
                <Route exact path="/inspection/:id/car" component={InspectionCarList} />
                <Route
                  exact
                  path="/inspection/:id/answer/:idAnswer/car/:idCar"
                  component={InspectionCARDetail}
                />
              </Switch>

              <Switch>
                <Route exact path="/training" component={TrainingList} />
                <Route
                  path="/training/new"
                  component={Authorization(user, NewTraining, 'Module', 'Training', true)}
                />
                <Route
                  exact
                  path="/training/:id"
                  component={Authorization(user, NewTraining, 'Module', 'Training', true)}
                />
              </Switch>

              <Route path="/support" component={Support} />

              {this.props.children}
            </Container>
          </div>
        )}
      </AppContext.Consumer>
    );
  }
}
